/* 
  
  
  
 */
import nextTick from 'next-tick';
export class Retainable {
    __refCount = 1;
    __disposeTimer = null;
    /* 
                                                                     
                                                 
                 
     */
    __disposeTimeout = 5000;
    retain() {
        if (this.__disposeTimer) {
            window.clearTimeout(this.__disposeTimer);
            this.__disposeTimer = null;
        }
        this.__refCount++;
        return this;
    }
    release() {
        if (this.__refCount <= 0) {
            //                                 
            debugger;
        }
        this.__refCount--;
        if (this.__refCount === 0) {
            if (this.__disposeTimeout) {
                this.__disposeTimer = window.setTimeout(() => {
                    this._dispose();
                }, this.__disposeTimeout);
            }
            else {
                this._dispose();
            }
            return true;
        }
        else {
            return false;
        }
    }
    releaseNextTick() {
        nextTick(() => this.release());
        return this;
    }
    /* 
                                                                                                  
      
      
                            
                              
     */
    async lock(fn) {
        this.retain();
        try {
            return await fn();
        }
        finally {
            this.release();
        }
    }
}
const safeMemWrap = (fn, obj) => {
    return async function (...args) {
        let o;
        if (this) {
            o = this; //       
        }
        else {
            o = obj; //         
        }
        if (o.__refCount <= 0) {
            throw new Error('Trying to call method on disposed object');
        }
        o.retain();
        try {
            const result = await fn.apply(o, args);
            return result;
        }
        finally {
            o.release();
        }
    };
};
export function memLock(target, key, descriptor) {
    //                                
    //                                                             
    //  
    if (descriptor === undefined) {
        //                               
        let value;
        if (target[key]) {
            value = safeMemWrap(target[key], target);
        }
        Object.defineProperty(target, key, {
            get: () => value,
            set: function (v) {
                return (value = safeMemWrap(v, this));
            },
            enumerable: true,
        });
        return null;
    }
    //       
    const originalMethod = descriptor.value;
    descriptor.value = safeMemWrap(originalMethod);
    return descriptor;
}
